import { render, staticRenderFns } from "./take-photos-usb.vue?vue&type=template&id=e163dcd8&scoped=true"
import script from "./take-photos-usb.vue?vue&type=script&lang=ts"
export * from "./take-photos-usb.vue?vue&type=script&lang=ts"
import style0 from "./take-photos-usb.vue?vue&type=style&index=0&id=e163dcd8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e163dcd8",
  null
  
)

export default component.exports